import React, { useState } from 'react';
import './FooterSection.css';
import { Link } from 'react-router-dom';


export default function FooterSection() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log(`Subscribed email: ${email}`);
    setEmail('');
  };

  const quickLinks = [
  { label: 'Home', to: '/' },
    { label: 'About CDOE', to: '/about' }, // 🔗 Updated target pointer logic path
    { label: 'Programs', to: '/programs' },


    { label: 'Fee Structure', to: '/fee-structure' },
    { label: 'Study Centres', to: '/study-centres' },
        { label: 'Announcements', to: '/announcements' },
            { label: 'Downloads', to: '/downloads' },

  ];

  const programLinks = [
    { label: 'BA', href: '/programs' },
    { label: 'BCom', href: '/programs' },
    { label: 'BBA', href: '/programs' },
    { label: 'BCA', href: '/programs' },
    { label: 'BSc', href: '/programs' },
    { label: 'MA', href: '/programs' },
    { label: 'MCom', href: '/programs' },
    { label: 'MBA', href: '/programs' },
    { label: 'MCA', href: '/programs' },
    { label: 'MSc', href: '/programs' },
    { label: 'MSW', href: '/programs' },
    { label: 'PG Diploma', href: '/programs' }
  ];

  return (
    <footer className="footer-wrapper">
      
      {/* 1. Top Bar: Newsletter Subscription */}
      <div className="newsletter-bar">
        <div className="newsletter-container">
          <div className="newsletter-text">
            <h3>Stay Updated</h3>
            <p>Subscribe to our newsletter for latest announcements</p>
          </div>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input 
              type="email" 
              placeholder="Enter your email address" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      {/* 2. Main Footer Links Directory Grid */}
      <div className="main-footer-links">
        <div className="footer-links-container">
          
          {/* Column 1: Brand Information & Social Profiles */}
          <div className="footer-col brand-info-col">
            <div className="footer-brand-header">
              <div className="footer-brand-icon">🎓</div>
              <div className="footer-brand-text">
                <h2>EDULEARNER</h2>
                <p>CDOE</p>
              </div>
            </div>
            <p className="footer-brand-desc">
              Centre for Distance and Online Education provides quality higher education to learners 
              across India through flexible distance learning programs.
            </p>
<div className="footer-social-icons">
  {/* WhatsApp */}
  <a 
    href="https://wa.me/917810027373" 
    className="social-link whatsapp" 
    target="_blank" 
    rel="noopener noreferrer" 
    aria-label="WhatsApp"
    title="WhatsApp"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M9.53 7.5C9.35 7.5 9.06 7.57 8.81 7.84C8.56 8.11 7.85 8.78 7.85 10.14C7.85 11.5 8.84 12.82 8.98 13C9.11 13.19 10.79 15.79 13.35 16.9C15.48 17.82 15.91 17.63 16.37 17.59C16.83 17.55 17.85 16.99 18.06 16.4C18.27 15.81 18.27 15.3 18.21 15.2C18.15 15.09 18 15.03 17.72 14.89C17.44 14.75 16.08 14.08 15.82 14C15.56 13.9 15.38 13.85 15.2 14.12C15.02 14.39 14.5 15.03 14.34 15.22C14.18 15.4 14.03 15.42 13.75 15.28C13.47 15.15 12.57 14.85 11.5 13.9C10.67 13.16 10.11 12.24 9.95 11.96C9.79 11.69 9.93 11.54 10.07 11.4C10.2 11.27 10.35 11.07 10.5 10.9C10.64 10.73 10.69 10.6 10.78 10.42C10.87 10.23 10.83 10.07 10.76 9.93C10.69 9.8 10.16 8.5 9.94 7.97C9.72 7.45 9.5 7.52 9.35 7.51L8.98 7.5H9.53Z"/>
    </svg>
  </a>

  {/* Instagram */}
  <a 
    href="https://www.instagram.com/alagappauniversitytpet?igsh=dWQxNzJqdGx4b2Vu" 
    className="social-link instagram" 
    target="_blank" 
    rel="noopener noreferrer" 
    aria-label="Instagram"
    title="Instagram"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  </a>

  {/* Facebook */}
  <a 
    href="https://www.facebook.com/share/1DBkWkki8w/" 
    className="social-link facebook" 
    target="_blank" 
    rel="noopener noreferrer" 
    aria-label="Facebook"
    title="Facebook"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
    </svg>
  </a>

  {/* X (Twitter) */}
  <a 
    href="https://x.com/meteducentre?s=11" 
    className="social-link twitter-x" 
    target="_blank" 
    rel="noopener noreferrer" 
    aria-label="X (Twitter)"
    title="X (Twitter)"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  </a>

  {/* YouTube */}
  <a 
    href="https://youtube.com/@alagappauniversitytpet?si=Kc4m6JIioH8qUCpY" 
    className="social-link youtube" 
    target="_blank" 
    rel="noopener noreferrer" 
    aria-label="YouTube"
    title="YouTube"
  >
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  </a>

  {/* Location / Google Maps */}
  <a 
    href="https://maps.app.goo.gl/4ttrRSq6B4H4z2hAA" 
    className="social-link gmaps" 
    target="_blank" 
    rel="noopener noreferrer" 
    aria-label="Google Maps"
    title="Google Maps"
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 21s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 7.2c0 7.3-8 11.8-8 11.8z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  </a>
</div>
          </div>


          {/* Column 2: Quick Links */}
          <div className="footer-col">
            <h3>QUICK LINKS</h3>
            <ul className="footer-links-list">
              {quickLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Academic Programs Index */}
          <div className="footer-col">
            <h3>PROGRAMS</h3>
            <ul className="footer-links-list programs-list-split">
              {programLinks.map((link, idx) => (
                <li key={idx}><Link to={link.href}>{link.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact Information */}
          <div className="footer-col contact-info-col">
            <h3>CONTACT US</h3>
            <div className="contact-item-row">
              <span className="contact-icon">📍</span>
            <p>
    <a 
      href="https://maps.app.goo.gl/4ttrRSq6B4H4z2hAA" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="link-hover-adjust"
    >
      Centre for Distance and Online Education,<br />
      EDULEARNER,<br />
      Thiruvannamalai,<br />
      India
    </a>
              </p>
            </div>
            <div className="contact-item-row">
              <span className="contact-icon">📞</span>
              <p><a href="tel:+914565241386" className="link-hover-adjust">+91-4565-241386</a></p>
            </div>
            <div className="contact-item-row">
              <span className="contact-icon">✉️</span>
              <p><a href="mailto:cdoe@edulearner.ac.in" className="link-hover-adjust">cdoe@edulearner.ac.in</a></p>
            </div>
          </div>

        </div>
      </div>

      {/* 3. Bottom Bar: Copyright & Legal Compliance Statements */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-container">
          <p className="copyright-text">
            &copy; 2026 EDULEARNER – Centre for Distance and Online Education. All rights reserved.
          </p>
          <div className="legal-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Use</a>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </div>

    </footer>
  );
}